import firebase from "firebase/app";
import {
    GET_ALL_USERS,
    GET_REQUIRED_QUALIFICATIONS,
    GET_QUALIFICATION_CATEGORIES,
    SET_VIEW_CATEGORY_DETAILS,
} from "./types";

export const getAllUsers = () => {
    return dispatch => {
        dispatch({ type: GET_ALL_USERS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", snapshot => {
                            dispatch({ type: GET_ALL_USERS.SUCCESS, payload: snapshot.val() });
                        });
                } else {
                    dispatch({ type: GET_ALL_USERS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_ALL_USERS.FAIL });
        }
    };
};
export const getRequiredQualifications = () => {
    return dispatch => {
        dispatch({ type: GET_REQUIRED_QUALIFICATIONS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/required_qualifications`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REQUIRED_QUALIFICATIONS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_REQUIRED_QUALIFICATIONS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_REQUIRED_QUALIFICATIONS.FAIL });
        }
    };
};
export const getQualificationCategories = () => {
    return dispatch => {
        dispatch({ type: GET_QUALIFICATION_CATEGORIES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/qualification_categories`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_QUALIFICATION_CATEGORIES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_QUALIFICATION_CATEGORIES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_QUALIFICATION_CATEGORIES.FAIL });
        }
    };
};
export const setViewQualCategoryDetail = (category = false, modalOpen = false) => {
    return dispatch => {
        dispatch({ type: SET_VIEW_CATEGORY_DETAILS, payload: { category, modalOpen } });
    };
};
